import { render, staticRenderFns } from "./ArticleBasketPreview.vue?vue&type=template&id=37f71879&scoped=true&"
import script from "./ArticleBasketPreview.vue?vue&type=script&lang=js&"
export * from "./ArticleBasketPreview.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBasketPreview.vue?vue&type=style&index=0&id=37f71879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f71879",
  null
  
)

export default component.exports